// @ts-nocheck

import React, { useState } from 'react';
import {Empty, Select, Space} from 'antd';
import {ExtendedDataProvider} from "../../types";
import {Link, useDataProvider} from "react-admin";
import FaIcon from "../Icons/FaIcon";
import {faRocket, faThLarge} from "@fortawesome/free-solid-svg-icons";


let timeout: ReturnType<typeof setTimeout> | null;
let currentValue: string;
const { Option } = Select;


const SearchBar = (props:any) => {
    const dataProvider: ExtendedDataProvider = useDataProvider();
    const [data, setData] = useState<any>([]);

    const fetch = (value: string, callback: Function) => {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        currentValue = value;

        const fetchData = () => {
            dataProvider.getAction('search', {verb: value, filter: {}})
                .then((response: any) => {
                    if (currentValue === value){
                        callback(response.data)}
                })
                .catch((error: any) => { console.error(error) })
        };
        if (value) {
            timeout = setTimeout(fetchData, 300);
        } else {
            callback([]);
        }
    };

    const handleSearch = (newValue: string) => {
        fetch(newValue, setData);
    };

    const getPOVText = (pov:string) => {
        if (pov==="consumer")
            return "Consumer"
        else if (pov==="serviceowner")
            return "Service Owner"
        return null
    };

    const SearchResultItem = ({ icon, model, name, pov }: { icon: any, model: string, name: string, pov: string }) => (
        <Space className='text-sm' style={{ display: 'flex', alignItems: 'center', padding: '4px 0' }}>
            {icon}
            <div>
                <div style={{ fontSize: 12, color: '#999' }}>{model}</div>
                <p style={{ color: 'black', margin: 0 }}>{name}</p>
                <span style={{ fontSize: 12, color: '#999' }}>{getPOVText(pov)}</span>
            </div>
        </Space>
    );

    const CardForService = (record: any) => {
        const service = record.record
        return (
            <Link to={`/${service.pov==="consumer"?"browse_services":"services"}/#${service.name}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                <SearchResultItem icon={FaIcon(faRocket)} model={service.model} name={service.name} pov={service.pov} />
            </Link>
        )
    };

    const CardForServiceItem = (record: any) => {
        const service_item = record.record
        return (
            <Link to={`/${service_item.pov==="consumer"?"service_items":"owner_service_items"}/${service_item.id}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                <SearchResultItem icon={FaIcon(faRocket)} model={service_item.model} name={service_item.name} pov={service_item.pov} />
            </Link>
        )
    };

    const CardForApplication = (record: any) => {
        const application = record.record
        return (
            <Link to={`/${application.pov==="consumer"?"applications":"owner_applications"}/#${application.name}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                <SearchResultItem icon={FaIcon(faThLarge)} model={application.model} name={application.name} pov={application.pov} />
            </Link>
        )
    };


    return (
        <Select
            showSearch
            value={null}
            placeholder={"Search"}
            style={props.style}
            className={props.className}
            defaultActiveFirstOption={false}
            notFoundContent={false}
            suffixIcon={null}
            filterOption={false}
            onSearch={handleSearch}
        >
            {
                Object.entries(data).length != 0?
                    Object.entries(data).map(([key, value]) => {
                        // @ts-ignore
                        return (
                            <Option value={key}>
                                {value.model==="Application"?<CardForApplication record={value}/>:<></>}
                                {value.model==="ServiceItem"?<CardForServiceItem record={value} />:<></>}
                                {value.model==="Service"?<CardForService record={value} />:<></>}
                            </Option>
                        )
                    })
                    :
                    !(currentValue === undefined || currentValue === '') &&
                    <Option value={0} >
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                               imageStyle={{height: "20px"}}
                               style={{height: "20px"}}
                               description={<span style={{fontSize: 14}}>No Results Found</span>
                        }
                        />
                    </Option>
            }
        </Select>
    );
};

export default SearchBar;
